import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../../app/store";

export interface ItemInfo {
  dir: boolean;
  id: string;
  name: string;
  size: number;
  type: string;
  modify: string;
  path: string;
}

export interface DirectoryItemsState {
  touched: boolean;
  itemInfo: ItemInfo;
}

const initialState: DirectoryItemsState = {
  touched: false,
  itemInfo: {
    dir: false,
    id: "",
    name: "",
    size: 0,
    type: "",
    modify: "",
    path: "",
  },
};

export const directoryItemsSlice = createSlice({
  name: "directoryItems",
  initialState,
  reducers: {
    directoryItemsTouchedAction: (state, action: PayloadAction<boolean>) => {
      state.touched = action.payload;
    },
    directoryItemsGetInfoAction: (state, action: PayloadAction<ItemInfo>) => {
      const newPayload = {
        dir: action.payload.dir,
        id: action.payload.id,
        name: action.payload.name,
        size: action.payload.size,
        type: action.payload.type,
        modify: action.payload.modify,
        path: action.payload.dir
          ? action.payload.path
              ?.split("/")
              .filter(
                (item: string, index: number) =>
                  index > 0 &&
                  index < action.payload.path?.split("/").length - 1
              )
              .join("/")
          : action.payload.path
              ?.split("/")
              .filter((item: string, index: number) => index > 0)
              .join("/"),
      };
      state.itemInfo = newPayload;
    },
    directoryItemsRemoveInfoAction: (state) => {
      state.itemInfo = initialState.itemInfo;
    },
  },
});

export const {
  directoryItemsTouchedAction,
  directoryItemsGetInfoAction,
  directoryItemsRemoveInfoAction,
} = directoryItemsSlice.actions;

export const directoryItems = (state: RootState) => state.directoryItemsState;

export default directoryItemsSlice.reducer;
